import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { Redirect, useRouter } from "expo-router";
import { ScrollView, View } from "react-native";
import { ShareMoodForm } from "@/elements/components/modals/share-mood-modal";
import Loader from "@/elements/components/shared/loader";
import ResponsiveContent from "@/elements/components/shared/responsive-content";
import { AppBar } from "@/elements/components/ui/app-bar";
import { api } from "@/elements/components/utils/convex-api";
import goBack from "@/elements/components/utils/go-back";

function MoodScreen() {
  const router = useRouter();
  const { data: pendingMoodReport, isLoading } = useQuery(
    convexQuery(api.student.home.queries.getPendingMoodReport, {}),
  );

  if (isLoading) {
    return <Loader />;
  }

  if (!pendingMoodReport?._id) {
    return <Redirect href="/home" />;
  }

  return (
    <View className="flex-1 bg-teachLoop-creamDark pt-safe">
      <AppBar>
        <AppBar.Icon onPress={goBack} />
        <AppBar.Title>Wellbeing check-in</AppBar.Title>
      </AppBar>
      <ScrollView className="flex-1 py-4">
        <ResponsiveContent>
          <ShareMoodForm
            lessonReportId={pendingMoodReport._id}
            subject={pendingMoodReport.subject}
            tutorFirstName={pendingMoodReport.tutorFirstName}
            lessonStart={pendingMoodReport.lessonStart}
            mandatory
            onComplete={(lessonReportId) => {
              router.push({
                pathname: "/(app)/lesson-history/[lessonReportId]",
                params: { lessonReportId, tab: "well-being" },
              });
            }}
          />
        </ResponsiveContent>
      </ScrollView>
    </View>
  );
}

export default MoodScreen;
